import { render, staticRenderFns } from "./ActivePolicies.vue?vue&type=template&id=2c78fc30&"
import script from "./ActivePolicies.vue?vue&type=script&lang=js&"
export * from "./ActivePolicies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports